/* eslint-disable */
import React from "react";
import { FaRegBell, FaRegEnvelope } from "react-icons/fa";
import styles from "./LK.module.css";
import { FaCamera } from "react-icons/fa";

export default function LKProfile({
  user,
  isTeacher,
  selfPhoto,
  unreadMessages,
  unreadAnnouncements,
  history,
  onChangePassword,
}) {
  const fields = isTeacher
    ? [
        { label: "Категория:", value: user.categor },
        { label: "Воинское звание:", value: user.militaryrank },
        {
          label: "Подразделение:",
          value: user.teacherDetails && user.teacherDetails.Podr,
        },
        {
          label: "Должность:",
          value: user.teacherDetails && user.teacherDetails.Position,
        },
        { label: "Телефон:", value: user["Phone home"] },
      ]
    : [
        { label: "Курс:", value: user.yeducationyear },
        { label: "Группа:", value: user.groupname },
        { label: "Категория:", value: user.categor },
        { label: "Воинское звание:", value: user.militaryrank },
        { label: "Телефон:", value: user["Phone home"] },
      ];

  return (
    <div className={styles.card}>
      <div className={`${styles.cardHeader} ${styles.cardHeaderOlive}`}>
        <span className={styles.cardHeaderTitleNormal}>ПРОФИЛЬ</span>
        <div className={styles.headerActions}>
          <button
            className={styles.iconBtn}
            onClick={() => history.push("/messages")}
            title="Сообщения"
          >
            <FaRegEnvelope size={14} color="#fff" />
            {!!unreadMessages && (
              <span className={styles.iconBadge}>{unreadMessages}</span>
            )}
          </button>
          <button
            className={styles.iconBtn}
            onClick={() => history.push("/announcement")}
            title="Объявления"
          >
            <FaRegBell size={14} color="#fff" />
            {!!unreadAnnouncements && (
              <span className={styles.iconBadge}>{unreadAnnouncements}</span>
            )}
          </button>
        </div>
      </div>

      <div className={styles.cardBody}>
        <div className={styles.photoWrap}>
          {selfPhoto
            ? <img className={styles.photo} src={selfPhoto} alt="" />
            : <div className={styles.noPhoto}>
                <FaCamera size={100} color="#5c76e3" />
              </div>
          }
        </div>

        <h3 className={styles.profileName}>
          {user.lastname} {user.firstname}
        </h3>
        <p className={styles.profilePatronymic}>{user.patronymic}</p>

        <div className={styles.fieldList}>
          {fields.map((field, index) => (
            <div key={index} className={styles.field}>
              <span className={styles.fieldLabel}>{field.label}</span>
              <span className={styles.fieldValue}>{field.value || "—"}</span>
            </div>
          ))}
        </div>

        <div className={styles.cardFooter}>
          <button className={styles.changePasswordBtn} onClick={onChangePassword}>
            Сменить пароль
          </button>
        </div>
      </div>
    </div>
  );
}
